import React from 'react';
import ListItemI18NRender from './ListItemI18NRender';
import ListItemRender from './ListItemRender';
import ListItemLink from './ListItemLink';
import ListItemI18NBig from './ListItemI18NBig';
import List from '@mui/material/List';
import ThemeProvider from '@mui/material/styles/ThemeProvider';
import { ListTheme } from './NewsStyling';
import { useTranslation } from 'react-i18next';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import CardMedia from '@mui/material/CardMedia';

export default function NewsItem(props) {
  const { t } = useTranslation(['news', 'common']);

  return (
    <Card elevation={0} sx={{alignItems:'center',justifyContent:'center'}}>
      <CardMedia
        component="img"
        sx={{height:300,width:300,ml:2}}
        image={props.item.tnUrl}
        alt={t("news:" + props.item.titleResKey)}
        title={t("news:" + props.item.titleResKey)}
        height="300"
        width="300"
      />
      <CardContent>
        <ThemeProvider theme={ListTheme}>
          <List sx={{mb:2,ml:-3}}>
            <ListItemI18NBig ns="news:" k={props.item.titleResKey}/>
            {(props.item.subtitleResKey)?<ListItemI18NRender ns="news:" k={props.item.subtitleResKey}/>:null}
            {(props.item.site1Inst)?<ListItemRender val={props.item.site1Inst}/>:null}
            {(props.item.site1Addr1)?<ListItemRender val={props.item.site1Addr1}/>:null}
            {(props.item.site1Addr2)?<ListItemRender val={props.item.site1Addr2}/>:null}
            {(props.item.site1Addr3)?<ListItemRender val={props.item.site1Addr3}/>:null}
            {(props.item.site1GoogleMapURL)?<ListItemLink val={props.item.site1GoogleMapURL} label="GoogleMaps"/>:null}
            {(props.item.site2Inst)?<ListItemRender val={props.item.site2Inst}/>:null}
            {(props.item.site2Addr1)?<ListItemRender val={props.item.site2Addr1}/>:null}
            {(props.item.site2Addr2)?<ListItemRender val={props.item.site2Addr2}/>:null}
            {(props.item.site2Addr3)?<ListItemRender val={props.item.site2Addr3}/>:null}
            {(props.item.site2GoogleMapURL)?<ListItemLink val={props.item.site2GoogleMapURL} label="GoogleMaps"/>:null}
            {(props.item.openingResKey)?<ListItemI18NRender ns="news:" k={props.item.openingResKey} labelKey=""/>:null}
            {(props.item.openHours1ResKey)?<ListItemI18NRender ns="news:" k={props.item.openHours1ResKey} labelKey="common:LABEL_OPENING_TIMES"/>:null}
            {(props.item.openHours2ResKey)?<ListItemI18NRender ns="news:" k={props.item.openHours2ResKey} labelKey="common:LABEL_OPENING_TIMES"/>:null}
            {(props.item.openHours3ResKey)?<ListItemI18NRender ns="news:" k={props.item.openHours3ResKey} labelKey="common:LABEL_OPENING_TIMES"/>:null}
            {(props.item.closingResKey)?<ListItemI18NRender ns="news:" k={props.item.closingResKey} labelKey=""/>:null}
            {(props.item.durationResKey)?<ListItemI18NRender ns="news:" k={props.item.durationResKey}/>:null}
            {(props.item.websiteURL)?<ListItemLink val={props.item.websiteURL} label={props.item.websiteName}/>:null}
          </List>
        </ThemeProvider>
      </CardContent>
    </Card>
  )
}